import Api from 'libs/api/index';

class InvoicesCertificated extends Api {
  constructor() {
    super('finance/invoices_certificateds/');
  }

  parseExcel(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      'parse_excel',
    );
  }

  approve(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      '/approve',
    );
  }

  export() {
    return this.buildQuery('post', {}, '/export');
  }

  filters() {
    return this.buildQuery('get', {}, 'filters');
  }
}

export default InvoicesCertificated;
